import { MEDIA, CATEGORY_GALLERY } from "../constants/media";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Galeria de fotos por setor — usa a 1ª foto (compat com landing).
export const COVER_PRESETS = {
  restauracao: { label: "Restauração", url: MEDIA.categoryRestauracao },
  logistica: { label: "Logística", url: MEDIA.categoryLogistica },
  retalho: { label: "Retalho", url: MEDIA.categoryRetalho },
  hotelaria: { label: "Hotelaria", url: MEDIA.categoryHotelaria },
  limpeza: { label: "Limpeza", url: MEDIA.categoryLimpeza },
  "apoio-ao-cliente": { label: "Apoio ao Cliente", url: MEDIA.categoryApoioCliente },
  construcao: { label: "Construção", url: MEDIA.categoryConstrucao },
  saude: { label: "Saúde", url: MEDIA.categorySaude },
  outros: { label: "Outros", url: MEDIA.heroWorker },
};

// Galeria expandida — 4 fotos por preset (para escolher no dialog)
export const PRESET_GALLERY = Object.keys(COVER_PRESETS).flatMap((key) => {
  const gallery = CATEGORY_GALLERY[key] || [COVER_PRESETS[key].url];
  return gallery.map((url, idx) => ({
    key: `${key}-${idx + 1}`,
    baseKey: key,
    label: `${COVER_PRESETS[key].label} ${idx + 1}`,
    categoryLabel: COVER_PRESETS[key].label,
    url,
  }));
});

const slug = (text) =>
  String(text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

// Hash determinístico simples (djb2) para escolher foto por seed
function seedHash(seed) {
  const s = String(seed || "");
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h + s.charCodeAt(i)) & 0xffffffff;
  }
  return Math.abs(h);
}

/** Foto do setor da vaga — último degrau da cascata (nunca falha). */
export function categoryCover(category, seed = "") {
  const key = slug(category) || "outros";
  const gallery = CATEGORY_GALLERY[key] || CATEGORY_GALLERY.outros;
  if (!gallery || gallery.length === 0) return MEDIA.heroWorker;
  const idx = seed ? seedHash(seed) % gallery.length : 0;
  return gallery[idx];
}

/** Devolve URL de um preset específico. Aceita "restauracao" (base) ou "restauracao-2" (índice). */
export function presetUrl(presetKey, fallbackCategory = "") {
  if (!presetKey) return categoryCover(fallbackCategory);
  const match = /^(.+)-(\d+)$/.exec(presetKey);
  if (match) {
    const base = match[1];
    const idx = parseInt(match[2], 10) - 1;
    const gallery = CATEGORY_GALLERY[base];
    if (gallery && gallery[idx]) return gallery[idx];
    if (gallery && gallery[0]) return gallery[0];
  }
  const gallery = CATEGORY_GALLERY[presetKey];
  if (gallery && gallery[0]) return gallery[0];
  return categoryCover(fallbackCategory);
}

/**
 * Imagem a mostrar para uma vaga:
 * foto própria da vaga (upload) → foto externa (scraping) → preset da galeria →
 * capa da empresa → foto do setor (aleatória mas determinística por id).
 */
export function jobCoverSrc(job) {
  const cover = job?.cover;
  // 1. Upload interno OU capa da empresa → URL relativa servida pelo backend
  if (cover?.url) return `${BACKEND}${cover.url}`;
  // 2. Foto externa vinda de scraping
  if (cover?.external_url) return cover.external_url;
  // 3. Preset da galeria (empresa/admin escolheu foto do setor)
  if (cover?.preset) return presetUrl(cover.preset, job?.category);
  // 4. Fallback determinístico por setor
  return categoryCover(job?.category, job?.id || job?.slug);
}
